import { render, staticRenderFns } from "./taskDialog.vue?vue&type=template&id=927c0840&scoped=true"
import script from "./taskDialog.vue?vue&type=script&lang=js"
export * from "./taskDialog.vue?vue&type=script&lang=js"
import style0 from "./taskDialog.vue?vue&type=style&index=0&id=927c0840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927c0840",
  null
  
)

export default component.exports